<template>
  <div>
    <v-row dense>
      <v-col>
        <a
          href="https://www.docomo.ne.jp/area/service_area/map/?icid=CRP_AREA_service_area_txt08_to_CRP_AREA_service_area_map&rgcd=03&cmcd=5G&scale=128000&lat=35.686254&lot=139.694936"
          target="_blank"
          >NTTドコモ</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a
          href="https://www.au.com/mobile/area/map/"
          target="_blank"
          >au</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a
          href="https://www.softbank.jp/mobile/network/area-map/"
          target="_blank"
          >ソフトバンク</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a href="https://network.mobile.rakuten.co.jp/area/" target="_blank"
          >楽天モバイル</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a href="https://www.uqwimax.jp/wimax/area/map/tokyo/" target="_blank"
          >UQ コミュニケーションズ</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a
          href="https://www.ymobile.jp/area/map/?pref=13&device_type=sp03_5g"
          target="_blank"
          >Y!mobile</a
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MobileAreaLink",
};
</script>
